import { applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import createLogger from 'redux-logger';
import freeze from 'redux-freeze';
import errorsConsultaServidor from './errorsConsultaServidor';

//Param the middlewares depending of the enviroment
const DEFAULT_ENVIROMENT = 'development';
let enviroment = DEFAULT_ENVIROMENT;
if (process && process.env && process.env.REACT_APP_ENVIROMENT) {
    enviroment = process.env.REACT_APP_ENVIROMENT;
}

/*
 * Middleware with:
 * - Redux DevTools
 * - Redux Logger
 * - Redux Thunk
 * - Custom errorsConsultaServidor
 ***/
function getMiddlewaresDevelopment() {
    const composeEnhancers = process.env.NODE_ENV === 'development' && typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
        : compose;

    const enhancer = composeEnhancers(applyMiddleware(thunk, freeze, createLogger(), errorsConsultaServidor));
    return enhancer;
}

/*
 * Middleware with:
 * - Redux Logger
 * - Redux Thunk
 * - Custom errorsConsultaServidor
 ***/
function getMiddlewaresProves() {
    return applyMiddleware(thunk, createLogger(), errorsConsultaServidor);
}

/*
 * Middleware with:
 * - Redux Thunk
 * - Custom errorsConsultaServidor
 ***/
function getMiddlewaresPerDefecte() {
    return applyMiddleware(thunk, errorsConsultaServidor);
}

/*
 * Returns the collection of middlewares
 ***/
export default function getMiddlewares() {
    switch (enviroment) {
        case 'development':
            return getMiddlewaresDevelopment();
        case 'proves':
            return getMiddlewaresProves();
        default:
            return getMiddlewaresPerDefecte();
    }
}



// WEBPACK FOOTER //
// ./src/middlewares/index.js